import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import TrendBadge from "@/components/base/TrendBadge";
import { categoryMap } from "@/mocks/categories";
import { formatHeat, type Topic } from "@/mocks/topics";

export default function TopicHero({ topic }: { topic: Topic }) {
  const cat = categoryMap[topic.category];

  return (
    <header className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-6 md:px-6 md:py-8">
        <Breadcrumb
          items={[
            { label: "首页", to: "/" },
            { label: "热门吃瓜榜", to: "/" },
            { label: cat?.name ?? "话题" },
            { label: topic.title },
          ]}
        />

        <div className="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="h-60 w-full overflow-hidden rounded-lg border border-background-200 md:h-80">
              <img
                src={topic.cover}
                alt={`${topic.title} 话题配图`}
                title={`${topic.title} - 51吃瓜榜焦点话题`}
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex flex-col justify-center lg:col-span-5">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-label font-medium text-primary-700">
                <i className="ri-file-list-3-line mr-1"></i>
                {cat?.name}
              </span>
              <span className="rounded-full bg-background-200 px-3 py-1 text-xs font-label text-foreground-600">
                第 {topic.rank} 名
              </span>
              <TrendBadge trend={topic.trend} value={topic.trendValue} />
            </div>

            <h1 className="mt-4 font-heading text-2xl font-black leading-snug tracking-tight text-foreground-950 md:text-4xl">
              {topic.title}
            </h1>

            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              {topic.summary}
            </p>

            <dl className="mt-6 grid grid-cols-3 gap-3">
              <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                <dt className="text-xs font-label text-foreground-500">实时热度</dt>
                <dd className="mt-1 font-heading text-lg font-bold text-primary-600">
                  {formatHeat(topic.heat)}
                </dd>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                <dt className="text-xs font-label text-foreground-500">围观讨论</dt>
                <dd className="mt-1 font-heading text-lg font-bold text-foreground-950">
                  {topic.comments}
                </dd>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                <dt className="text-xs font-label text-foreground-500">更新</dt>
                <dd className="mt-1 font-heading text-base font-bold text-foreground-950">
                  {topic.updatedAt}
                </dd>
              </div>
            </dl>

            <div className="mt-5 flex flex-wrap gap-2">
              {topic.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-50 px-3 py-1 text-xs font-label text-secondary-700"
                >
                  #{tag}
                </span>
              ))}
            </div>

            <Link
              to="/#rank"
              className="mt-6 flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-arrow-left-line"></i>
              回到完整榜单
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}